"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const grid_observer_1 = require("@ebay-business-components/grid-observer");
class default_1 extends Marko.Component {
    onCreate() {
        const width = Math.floor(Math.random() * 100) + 50;
        const height = Math.floor(Math.random() * 100) + 50;
        this.state = { aspectRatio: (0, grid_observer_1.getAspectRatio)(width, height) };
    }
}
exports.default = default_1;
//# sourceMappingURL=component.js.map